import React from "react"
export function Moon(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <g
        id="prefix__Single-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M9.041 2.006a8.029 8.029 0 108.953 8.954.727.727 0 00-1.06-.733 5.303 5.303 0 01-7.16-7.161.727.727 0 00-.733-1.06zM7.956 3.732l-.046.172a6.758 6.758 0 006.56 8.384l.332-.009c.44-.02.873-.085 1.294-.189l.171-.046-.019.059a6.573 6.573 0 11-8.584-8.266l.292-.105z"
          fill="currentColor"
          fillRule="nonzero"
          id="prefix__moon"
        />
      </g>
    </svg>
  )
}
